export { Chip, type ChipProps, type ChipTone } from './chip';
